import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

import OSCard from "../../OSCard/OSCard";

class HomeEvents extends Component {
  render() {
    const { events, language } = this.props.events;
    return (
      <Row>
        {events.length > 0 &&
          events.map((event) => {
            return (
              <Col xs={12} sm={6} lg={4} key={event.id}>
                <OSCard
                  key={event.id}
                  id={event.id}
                  image={event.imageUrl}
                  title={event.eventName}
                  link={event.link}
                  startDate={event.eventVenues[0].startDate}
                  endDate={event.eventVenues[0].endDate}
                  venueName={event.eventVenues[0].venueName}
                  description={event.description}
                  lat={event.eventVenues[0].latitude}
                  lng={event.eventVenues[0].longitude}
                  language={language}
                />
              </Col>
            );
          })}
      </Row>
    );
  }
}

export default HomeEvents;



// WEBPACK FOOTER //
// ./src/components/Pages/Home/HomeEvents.js